var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAiBestMatch = function SvgAiBestMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AiBestMatch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.1a.4.4 0 0 1 .38.274l.026.077a2.6 2.6 0 0 0 1.644 1.644l.077.026a.4.4 0 0 1 0 .759l-.077.025a2.6 2.6 0 0 0-1.644 1.645l-.026.077a.4.4 0 0 1-.759 0l-.026-.077a2.6 2.6 0 0 0-1.644-1.645l-.077-.025a.4.4 0 0 1 0-.76l.077-.025a2.6 2.6 0 0 0 1.644-1.644l.026-.077a.4.4 0 0 1 .38-.274Z",
    fill: "url(#AiBestMatch_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4a.5.5 0 0 1 .485.379l.127.507a5.5 5.5 0 0 0 4.002 4.002l.507.127a.5.5 0 0 1 0 .97l-.507.127a5.5 5.5 0 0 0-4.002 4.002l-.127.507a.5.5 0 0 1-.97 0l-.127-.507a5.5 5.5 0 0 0-4.002-4.002l-.507-.127a.5.5 0 0 1 0-.97l.507-.127a5.5 5.5 0 0 0 4.002-4.002l.127-.507A.5.5 0 0 1 8.5 4Z",
    fill: "url(#AiBestMatch_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AiBestMatch_svg__b",
    x1: 3,
    y1: 8.55,
    x2: 15.901,
    y2: 8.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AiBestMatch_svg__c",
    x1: 3,
    y1: 8.55,
    x2: 15.901,
    y2: 8.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AiBestMatch_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgAiBestMatch;